import React from 'react'

import { InlineSelect, SidebarLabel } from '../scharedStyles/style'

const FilterSelect = ({
    label,
    value,
    onChange,
    options,
    placeholder,
}) => (
    <>
        <SidebarLabel>{label}</SidebarLabel>
        <InlineSelect
            showSearch
            allowClear
            value={value ?? undefined}
            onChange={onChange}
            options={options}
            placeholder={placeholder}
        />
    </>
)

export default FilterSelect
